import {Facebook, Instagram, Linkedin, MessageCircleDashed as MessageCircle} from 'lucide-react';
import { Link } from 'react-router-dom';
import Logo from '@/components/Logo';

const emBreveTag = (
  <span className="ml-2 text-[11px] uppercase tracking-wide text-[#FFCCBC] bg-[#5D4037]/70 border border-[#8D6E63] rounded-full px-2 py-0.5">
    Em breve
  </span>
);

function Footer() {
  return (
    <footer id="contato" className="bg-gradient-to-b from-[#2C2C2C] to-black text-white border-t-2 border-[#5D4037]">
      <div className="max-w-7xl mx-auto sm:px-6 lg:px-8 pt-[31px] pl-[16px] pr-[16px] pb-[18px]">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4 pt-[0px] pb-[7px]">
            <Logo size="md" />
            <p className="text-gray-300 text-sm leading-relaxed">
              A comunidade mundial dos profissionais da gastronomia brasileira.
            </p>
            {/* Social Media - ainda sem perfis publicos */}
            <div className="flex items-center gap-4 pt-[6px]">
              <span className="bg-[#5D4037]/60 p-3 rounded-full border border-[#8D6E63] text-gray-400" title="Em breve">
                <Facebook size={20} />
              </span>
              <span className="bg-[#5D4037]/60 p-3 rounded-full border border-[#8D6E63] text-gray-400" title="Em breve">
                <Instagram size={20} />
              </span>
              <span className="bg-[#5D4037]/60 p-3 rounded-full border border-[#8D6E63] text-gray-400" title="Em breve">
                <Linkedin size={20} />
              </span>
            </div>
            <p className="text-xs text-gray-500">Redes sociais em breve</p>
          </div>

          {/* Para Trabalhadores */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-[#E53935]">Para Profissionais</h4>
            <ul className="space-y-3 text-gray-300 text-sm">
              <li>
                <Link to="/cadastro?redirect=curriculo" className="hover:text-[#E53935] transition-colors no-underline text-gray-300">
                  Criar Curriculo
                </Link>
              </li>
              <li>
                <Link to="/vagas" className="hover:text-[#E53935] transition-colors no-underline text-gray-300">
                  Buscar Vagas
                </Link>
              </li>
              <li className="flex items-center text-gray-500">
                Dicionario Tecnico
                {emBreveTag}
              </li>
              <li className="flex items-center text-gray-500">
                Guia de Documentacao
                {emBreveTag}
              </li>
              <li>
                <Link to="/perfil" className="hover:text-[#E53935] transition-colors no-underline text-gray-300">
                  Meu Perfil
                </Link>
              </li>
            </ul>
          </div>

          {/* Para Restaurantes */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-[#E53935]">Para Estabelecimentos</h4>
            <ul className="space-y-3 text-gray-300 text-sm">
              <li>
                <Link to="/criar-vaga" className="hover:text-[#E53935] transition-colors no-underline text-gray-300">
                  Publicar Vaga
                </Link>
              </li>
              <li>
                <Link to="/buscar-usuarios" className="hover:text-[#E53935] transition-colors no-underline text-gray-300">
                  Buscar Candidatos
                </Link>
              </li>
              <li className="flex items-center text-gray-500">
                Planos e Precos
                {emBreveTag}
              </li>
              <li>
                <Link to="/perfil" className="hover:text-[#E53935] transition-colors no-underline text-gray-300">
                  Gerenciar Vagas
                </Link>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-[#E53935]">Contato</h4>
            <p className="text-gray-300 text-sm leading-relaxed">
              Duvidas, sugestoes ou quer fazer parte da comunidade? Fale com a gente.
            </p>
            <a
              href="mailto:contato@bbqjobs.com"
              className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#C62828] to-[#E53935] text-white px-4 py-3 rounded-lg font-semibold hover:shadow-lg hover:shadow-[#E53935]/50 transition-all text-sm border border-[#8D0000] no-underline">
              <MessageCircle size={16} />
              Fale conosco
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#5D4037] flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400 mt-[26px] pt-[11px]">
          <div>
            &copy; 2026 BBQ Jobs. Todos os direitos reservados.
          </div>
          <div className="flex flex-wrap justify-center gap-6 text-gray-500">
            <span>Politica de Privacidade (em breve)</span>
            <span>Termos de Uso (em breve)</span>
            <span>FAQ (em breve)</span>
          </div>
        </div>
      </div>
    </footer>);

}

export default Footer;
